import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useBookmarks } from "@/hooks/useBookmarks";

const navItems = [
  { label: "首页", to: "/" },
  { label: "话题库", to: "/topics" },
  { label: "关于我们", to: "/about" },
  { label: "常见问题", to: "/faq" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { saved } = useBookmarks();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-background-300"
          : "bg-background-50 border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
          <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading text-xl font-bold">
            5
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl md:text-2xl font-bold text-foreground-950 tracking-tight">
              5看料网
            </span>
            <span className="hidden sm:block text-[11px] text-foreground-500 mt-1 tracking-wider">
              热点 · 话题 · 收藏回看
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
          {navItems.map((item) => {
            const active =
              item.to === "/" ? location.pathname === "/" : location.pathname.startsWith(item.to);
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  active
                    ? "text-primary-700 bg-primary-100"
                    : "text-foreground-700 hover:text-primary-700 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <Link
            to="/topics"
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-bookmark-3-line"></i>
            <span>我的收藏</span>
            <span className="min-w-5 h-5 px-1.5 flex items-center justify-center rounded-full bg-background-50/25 text-xs">
              {saved.length}
            </span>
          </Link>

          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer hover:bg-background-100 transition-colors"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-4">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="px-4 py-3 rounded-md text-sm font-medium text-foreground-800 hover:bg-background-100 hover:text-primary-700 transition-colors cursor-pointer"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/topics"
              className="mt-2 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium cursor-pointer"
            >
              <i className="ri-bookmark-3-line"></i>
              <span>我的收藏（{saved.length}）</span>
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}